import React from 'react';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      fontSize: 16,
      fontWeight: 400,
      color: theme.palette.grey['500'],
      marginLeft: 21,
      letterSpacing: '-0.3px',
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  }),
);
interface Props {
  children: React.ReactNode;
}

const Information: React.FC<Props> = (props: Props) => {
  const { children } = props;
  const classes = useStyles();

  return <span className={classes.root}>{children}</span>;
};

export default Information;
